<template>
	<div class="item3">
		<img class="logoico" src="../assets/images/logo.png" />
		<back></back>
		<div class="item3box">
			<div class="title">
				<div>著作篇</div>
			</div>
			<div class="content">
				<div class="content-left">
					<div>
						<a href="javascript:void(0);" @click="select(1)">
							<img v-if="shownum" src="../assets/images/item3btn1active.png" />
							<img v-else src="../assets/images/item3btn1.png" />
						</a>
					</div>
					<div>
						<a href="javascript:void(0);" @click="select(2)">
							<img v-if="shownum" src="../assets/images/iten3btn2.png" />
							<img v-else src="../assets/images/item3btn2active.png" />
						</a>
					</div>
				</div>
				<div class="content-right">
					<img class="content-right-bag" src="../assets/images/item3bagvideo.png" />
					<div class="content-right-txt" v-if="shownum">
						<video v-if="showlist!=null" controls="controls" controlslist="nodownload"
							style="width= 100%; height=100%;"
							:src="$api.imgUrl +''+ showlist.videoAtt.fastFileId"></video>
						<div class="content-right-txt2">
							<div v-if="showlist!=null">
								<span>{{showlist.title}}:</span>
								<div v-html="showlist.content"></div>

							</div>
						</div>
					</div>
					<div class="content-right-txt" v-else>
						<video v-if="showlist!=null" controls="controls" controlslist="nodownload"
							style="width= 100%; height=100%;"
							:src="$api.imgUrl +''+ showlist.videoAtt.fastFileId"></video>
						<div v-if="showlist!=null" class="content-right-txt2">
							<div>
								<span>{{showlist.title}}:</span>
								<div v-html="showlist.content"></div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import back from '../components/backhome/back.vue'

	import axios from 'axios'
	export default {
		components: {
			back
		},
		data() {
			return {
				token: this.$store.state.token,
				userid: this.$store.state.userid,
				shownum: true,
				classlist: null,
				showlist: null
			}
		},
		created() {
			this.getlist()
		},
		methods: {
			getlist() {
				axios({
					method: 'GET',
					url: this.$api.commonUrl + 'posts',
					params: {
						pageNum: 1,
						pageSize: 999
					},
					headers: {
						"Authorization": "Bearer " + this.token
					},
					responseType: "json"
				}).then(res => {
					if (res.data.code == '200') {
						let newlistsss = []
						res.data.data.list.map((item) => {
							if (item.cmsCategoryList[0].name === '著作篇') {
								newlistsss.push(item)
							}
						})
						newlistsss.map((item) => {
							if (item.title === '千金要方') {
								this.showlist = item
							}
						})
						this.classlist = newlistsss

					} else {
						console.log(res.data.message)
					}
				}).catch(err => {
					console.log(err)
				})
			},
			select(num) {
				if (this.shownum & num === 2) {
					this.shownum = false
					this.showlist = this.classlist[0]
					this.classlist.map((item) => {
						if (item.title === '千金翼方') {
							this.showlist = item
						}
					})
				} else {
					this.shownum = true
					this.showlist = this.classlist[1]
					this.classlist.map((item) => {
						if (item.title === '千金要方') {
							this.showlist = item
						}
					})
				}

			}
		},

	}
</script>

<style scoped>
	.item3 {
		background: url(../assets/images/item5bag.jpg) no-repeat;
		background-size: 120% auto;
		background-position: left center;
		width: 100%;
		height: 100%;
		position: absolute;
		z-index: 1;
	}

	.item3 .item3box {
		position: absolute;
		z-index: 3;
		left: 1rem;
		top: 8rem;
		right: 1rem;
		bottom: 1rem;
		text-align: center;
	}

	.item3 .logoico {
		position: absolute;
		top: 3rem;
		left: 3rem;
		width: 18rem;
	}

	.item3 .title {
		height: 6rem;
		text-align: center;
	}

	.item3 .title div {
		line-height: 6rem;
		width: calc(6rem * 6.39);
		height: 6rem;
		margin: 0px auto;
		background: url(../assets/images/itemtitlebag.png) no-repeat;
		background-size: 100%;
		font-family: 'STXingkai';
		font-size: 3rem;
		color: #FFFFFF;
	}

	.item3 .content {
		width: 80rem;
		height: 51rem;
		margin: 0px auto;
		position: relative;
		margin-top: 2rem;
		display: flex;
	}

	.item3 .content-left {
		width: 15rem;
		height: 100%;
		display: flex;
		flex-wrap: wrap;
	}

	.item3 .content-left div {
		width: 100%;
		position: relative;
	}

	.item3 .content-left div:first-child img {
		top: 0;
	}

	.item3 .content-left div:last-child img {
		bottom: 0;
	}

	.item3 .content-left div img {
		width: 14.16rem;
		position: absolute;
		margin: auto;
		left: 0;
		right: 0;
	}

	.item3 .content-right {
		width: 65rem;
		height: 100%;
		position: relative;
	}

	.item3 .content-right-bag {
		width: 100%;
		height: 100%;
		display: block;
	}

	.item3 .content-right-txt {
		position: absolute;
		left: 1rem;
		right: 1rem;
		top: 1rem;
		bottom: 1rem;
	}

	.item3 .content-right-txt video {
		width: 100%;
		height: 35.2rem;
		display: block;
	}

	.item3 .content-right-txt2 {
		width: 100%;
		height: 13.5rem;
		background: url(../assets/images/txtbagvideo2.png) no-repeat;
		background-size: 100%;
		position: relative;
		margin-top: 0.5rem;
	}

	.item3 .content-right-txt2 div {
		position: absolute;
		top: 1.8rem;
		left: 1rem;
		right: 1rem;
		bottom: 1rem;
		overflow-y: auto;
		color: #8d6141;
		font-size: 1rem;
		line-height: 1.5rem;
		text-align: left;
	}

	.item3 .content-right-txt2 div span {
		text-align: left;
		font-size: 1.142857rem;
		font-weight: bold;
		line-height: 2rem;
		color: #5f3519;
		display: block;
	}

	.item3 .content-right-txt2 div::-webkit-scrollbar {
		width: 6px;
		/*高宽分别对应横竖滚动条的尺寸*/
		height: 1px;
	}

	/*滚动条里面小方块*/
	.item3 .content-right-txt2 div::-webkit-scrollbar-thumb {
		border-radius: 10px;
		box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
		background: #af805c;
	}

	/*滚动条里面轨道*/
	.item3 .content-right-txt2 div::-webkit-scrollbar-track {
		box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
		border-radius: 10px;
		background: #ede3db;
	}
</style>
